

import { createSlice } from "@reduxjs/toolkit";
const INITIAL_STATE = {
    isSuccess: true,
    showPopup: false,
    data: null,
    type: "",
    message: "",
    headingText: "",
    showQualtricsFeedback: false
}

const commonDialogPopupSlice = createSlice({
    name: 'commonDialogHandler',
    initialState: INITIAL_STATE,
    reducers: {
        showCommonPopup: (state, action): any => {

            return {
                ...state,
                ...action.payload
            }
        },
        resetCommonPopup: (): any => {
            return {
                ...INITIAL_STATE
            }
        },
        clearCommonPopup: (state): any => {
            return {
                ...state,
                showPopup : false,
                showQualtricsFeedback: false
            }
        }
    },
});
export const { showCommonPopup,resetCommonPopup, clearCommonPopup } = commonDialogPopupSlice.actions;
export default commonDialogPopupSlice.reducer;